<template>
	<v-container fluid>
		<v-row v-if="dataFetched == codebooks.length">
			<v-col class="mx-3 mt-0 pt-0 codebook-table" v-for="codebook in codebooks" :key="codebook.id" cols="2">
				<v-row class="codebook-title pa-1" style="background-color: #d4d4d4">
					{{ codebook.title }}
				</v-row>
				<v-row>
					<v-col
						style="
							height: 250px;
							overflow-y: auto;
							overflow-x: hidden;
							scrollbar-color: #888888 rgb(203, 203, 203);
							scrollbar-width: thin;
							background-color: #eeeeee;
							padding-block: 3px;
						"
					>
						<v-row
							class="pa-1 flex-nowrap codebook-entry"
							v-for="entry in codebook.data"
							:key="entry.id"
							style="font-size: 0.85rem"
						>
							<span v-if="entry.date">{{ entry.date }}</span>
							<span v-if="entry.name">{{ entry.name }}</span>
							<v-spacer></v-spacer>
							<v-icon small style="cursor: pointer" @click="deleteEntryClick(entry, codebook.table)"
								>fa-trash</v-icon
							>
						</v-row>
					</v-col>
				</v-row>
				<v-row style="background-color: #d4d4d4" class="pa-1 d-flex justify-center">
					<v-btn small @click="addNewEntryClick(codebook)"><v-icon small>fa-add</v-icon></v-btn>
				</v-row>
			</v-col>
		</v-row>
		<v-row v-else class="pa-5 justify-center">
			<v-col cols="4">
				<v-row class="justify-center">
					<span style="font-size: 1.2rem; color: #888888"> Dohvaćanje podataka u tijeku...</span>
				</v-row>
			</v-col>
		</v-row>
		<v-dialog v-model="addNewEntryShow" persistent width="30%">
			<v-card>
				<v-col class="pa-5">
					<v-row class="px-3 mb-3">
						<DatePicker
							v-if="newEntryDataType == 'date'"
							v-model="newEntryValue"
							:dateLabel="$t('fields.date')"
						></DatePicker>
						<InputField v-else v-model="newEntryValue" :label="$t('fields.value')"></InputField>
					</v-row>
					<v-row class="px-3 justify-center">
						<v-btn @click="addNewEntrySave" color="primary">Dodaj</v-btn>
						<v-spacer></v-spacer>
						<v-btn @click="addNewEntryClose">Odustani</v-btn>
					</v-row>
				</v-col>
			</v-card>
		</v-dialog>
	</v-container>
</template>

<script>
import InputField from '../../trinkets/InputField';
import DatePicker from '@/components/trinkets/DatePicker';

export default {
	name: 'Codebooks',
	components: { InputField, DatePicker },
	data: function () {
		return {
			codebooks: [
				{
					id: 1,
					table: 'membership_start_dates',
					title: 'Datum stupanja u članstvo',
					data: [],
					dataType: 'date',
				},
				{ id: 2, table: 'nationalities', title: 'Narodnost', data: [], dataType: 'string' },
				/* 				{ id: 3, table: 'professions', title: 'Zvanje', data: [], dataType: 'string' },
				 */ { id: 3, table: 'qualifications', title: 'Stručna sprema', data: [], dataType: 'string' },
				{ id: 4, table: 'academic_titles', title: 'Akademsko zvanje', data: [], dataType: 'string' },
				{ id: 5, table: 'countries', title: 'Države', data: [], dataType: 'string' },
			],
			dataFetched: 0,
			newEntryTable: null,
			newEntryValue: null,
			newEntryDataType: null,
			addNewEntryShow: false,
		};
	},
	methods: {
		getAllData() {
			let vm = this;
			this.codebooks.forEach((codebook) => {
				this.$APICall(
					'get',
					'codebooks-data/' + codebook.table,
					{},
					(data, success) => {
						if (success) {
							codebook.data = data;
						} else {
							vm.$alert(vm.$t('alerts.basicError'));
						}
						vm.dataFetched += 1;
					},
					true
				);
			});
		},
		addNewEntryClick(entity) {
			this.newEntryTable = entity.table;
			this.newEntryDataType = entity.dataType;
			this.addNewEntryShow = true;
		},
		addNewEntrySave() {
			let vm = this;
			this.$APICall(
				'post',
				'codebooks-data',
				{ table: this.newEntryTable, value: this.newEntryValue },
				(data, success) => {
					if (success) {
						vm.dataFetched = 0;
						vm.getAllData();
						vm.addNewEntryClose();
					} else {
						vm.$alert(vm.$t('alerts.basicError'));
					}
				},
				true
			);
		},
		addNewEntryClose() {
			this.newEntryTable = null;
			this.addNewEntryShow = false;
			this.newEntryValue = null;
			this.newEntryDataType = null;
		},
		deleteEntryClick(entry, entryTable) {
			let vm = this;
			this.$verify(this.$t('alerts.deletionQuestion'), (result) => {
				if (result) {
					this.$APICall(
						'post',
						'codebooks-data-delete',
						{ table: entryTable, id: entry.id },
						(data, success) => {
							if (success) {
								vm.dataFetched = 0;
								vm.getAllData();
							} else {
								if (data == 'Used') {
									vm.$alert('Vrijednost se koristi stoga ne može biti obrisana');
								} else {
									vm.$alert(vm.$t('alerts.basicError'));
								}
							}
						},
						true
					);
				}
			});
		},
	},
	mounted() {
		if (!this.$myStore.state.loggedIn) {
			this.$router.replace('login');
		}
		this.$myStore.commit('setBreadcrumbs', [
			{ text: this.$t('modules.codebooks'), href: '/#/codebooks', disabled: true },
		]);
		this.getAllData();
	},
};
</script>

<style scoped>
.codebook-entry {
	cursor: default;
	padding-inline: 10px !important;
	transition: background-color 200ms;
}
.codebook-entry:hover {
	background-color: #009dc03d;
}
</style>
